// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import { BillStatusAndTypeFragmentDoc } from '../../../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TaskBillModal_SaveBillsMutationVariables = Types.Exact<{
  input: Types.SaveBillsInput;
}>;


export type TaskBillModal_SaveBillsMutation = { __typename?: 'Mutation', saveBills: { __typename?: 'SaveBillsResult', bills: Array<{ __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }>, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }> } };

export type TaskBillModal_ProtoBillsQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type TaskBillModal_ProtoBillsQuery = { __typename?: 'Query', task: { __typename?: 'Task', id: string, protoBills: Array<{ __typename?: 'ProtoBill', id: string, existingBills: Array<{ __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }>, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }>, lineItems: Array<{ __typename?: 'ProtoBillLineItem', amountInCents: number, commitmentLineItem: { __typename?: 'CommitmentLineItem', id: string, unbilledInCents: number, billedInCents?: number | null | undefined, pendingUnbilledInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, task?: { __typename?: 'Task', id: string } | null | undefined, projectStage: { __typename?: 'ProjectStage', id: string }, project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } }, owner: { __typename?: 'Commitment', id: string, accountingNumber: number, projectStage: { __typename?: 'ProjectStage', id: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } } }>, tradePartner: { __typename?: 'TradePartner', id: string, name: string } }> } };

export type TaskBillModal_ProtoBillFragment = { __typename?: 'ProtoBill', id: string, existingBills: Array<{ __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }>, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } }>, lineItems: Array<{ __typename?: 'ProtoBillLineItem', amountInCents: number, commitmentLineItem: { __typename?: 'CommitmentLineItem', id: string, unbilledInCents: number, billedInCents?: number | null | undefined, pendingUnbilledInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, task?: { __typename?: 'Task', id: string } | null | undefined, projectStage: { __typename?: 'ProjectStage', id: string }, project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } }, owner: { __typename?: 'Commitment', id: string, accountingNumber: number, projectStage: { __typename?: 'ProjectStage', id: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } } }>, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export type TaskBillModal_LineItemsFragment = { __typename?: 'CommitmentLineItem', id: string, unbilledInCents: number, billedInCents?: number | null | undefined, pendingUnbilledInCents: number, projectItem: { __typename?: 'ProjectItem', displayName: string, id: string, name: string, item: { __typename?: 'Item', id: string, fullCode: string }, task?: { __typename?: 'Task', id: string } | null | undefined, projectStage: { __typename?: 'ProjectStage', id: string }, project: { __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string } }, owner: { __typename?: 'Commitment', id: string, accountingNumber: number, projectStage: { __typename?: 'ProjectStage', id: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } } };

export type TaskBillModal_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, projectStage: { __typename?: 'ProjectStage', id: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } };

export type TaskBillModal_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, commitment: { __typename?: 'Commitment', id: string, projectStage: { __typename?: 'ProjectStage', id: string } }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, blueprintUrl: { __typename?: 'Url', path: string } };

export type TaskBillModal_BillFragment = { __typename?: 'Bill', id: string, isDeferred: boolean, internalNote?: string | null | undefined, tradePartnerNumber: string, source: { __typename?: 'BillSourceDetail', code: Types.BillSource, name: string }, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, parents: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } } | { __typename?: 'CommitmentChangeOrder', id: string, accountingNumber: number, blueprintUrl: { __typename?: 'Url', path: string } }>, projectStage: { __typename?: 'ProjectStage', id: string }, lineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined, task?: { __typename?: 'Task', id: string } | null | undefined }>, type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus } };

export const TaskBillModal_BillFragmentDoc = gql`
    fragment TaskBillModal_Bill on Bill {
  id
  ...BillStatusAndType
  source {
    code
    name
  }
  isDeferred
  tradePartner {
    ...Named
  }
  parents {
    id
    accountingNumber
    blueprintUrl {
      path
    }
  }
  internalNote
  projectStage {
    id
  }
  tradePartnerNumber
  lineItems {
    id
    amountInCents
    commitmentLineItem {
      id
    }
    task {
      id
    }
  }
}
    ${BillStatusAndTypeFragmentDoc}
${NamedFragmentDoc}`;
export const TaskBillModal_CommitmentFragmentDoc = gql`
    fragment TaskBillModal_Commitment on Commitment {
  id
  projectStage {
    id
  }
  id
  accountingNumber
  tradePartner {
    ...Named
  }
  blueprintUrl {
    path
  }
}
    ${NamedFragmentDoc}`;
export const TaskBillModal_ChangeOrderFragmentDoc = gql`
    fragment TaskBillModal_ChangeOrder on CommitmentChangeOrder {
  id
  commitment {
    id
    projectStage {
      id
    }
  }
  accountingNumber
  tradePartner {
    ...Named
  }
  blueprintUrl {
    path
  }
}
    ${NamedFragmentDoc}`;
export const TaskBillModal_LineItemsFragmentDoc = gql`
    fragment TaskBillModal_LineItems on CommitmentLineItem {
  id
  unbilledInCents
  billedInCents
  pendingUnbilledInCents
  projectItem {
    ...Named
    displayName
    item {
      id
      fullCode
    }
    task {
      id
    }
    projectStage {
      id
    }
    project {
      id
    }
  }
  owner {
    ... on Commitment {
      ...TaskBillModal_Commitment
    }
    ... on CommitmentChangeOrder {
      ...TaskBillModal_ChangeOrder
    }
  }
}
    ${NamedFragmentDoc}
${TaskBillModal_CommitmentFragmentDoc}
${TaskBillModal_ChangeOrderFragmentDoc}`;
export const TaskBillModal_ProtoBillFragmentDoc = gql`
    fragment TaskBillModal_ProtoBill on ProtoBill {
  id
  existingBills {
    ...TaskBillModal_Bill
  }
  lineItems {
    commitmentLineItem {
      ...TaskBillModal_LineItems
    }
    amountInCents
  }
  tradePartner {
    ...Named
  }
}
    ${TaskBillModal_BillFragmentDoc}
${TaskBillModal_LineItemsFragmentDoc}
${NamedFragmentDoc}`;
export const TaskBillModal_SaveBillsDocument = gql`
    mutation TaskBillModal_SaveBills($input: SaveBillsInput!) {
  saveBills(input: $input) {
    bills {
      ...TaskBillModal_Bill
      tradePartner {
        ...Named
      }
    }
  }
}
    ${TaskBillModal_BillFragmentDoc}
${NamedFragmentDoc}`;
export type TaskBillModal_SaveBillsMutationFn = Apollo.MutationFunction<TaskBillModal_SaveBillsMutation, TaskBillModal_SaveBillsMutationVariables>;

/**
 * __useTaskBillModal_SaveBillsMutation__
 *
 * To run a mutation, you first call `useTaskBillModal_SaveBillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskBillModal_SaveBillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskBillModalSaveBillsMutation, { data, loading, error }] = useTaskBillModal_SaveBillsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskBillModal_SaveBillsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TaskBillModal_SaveBillsMutation, TaskBillModal_SaveBillsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TaskBillModal_SaveBillsMutation, TaskBillModal_SaveBillsMutationVariables>(TaskBillModal_SaveBillsDocument, options);
      }
export type TaskBillModal_SaveBillsMutationHookResult = ReturnType<typeof useTaskBillModal_SaveBillsMutation>;
export type TaskBillModal_SaveBillsMutationResult = Apollo.MutationResult<TaskBillModal_SaveBillsMutation>;
export type TaskBillModal_SaveBillsMutationOptions = Apollo.BaseMutationOptions<TaskBillModal_SaveBillsMutation, TaskBillModal_SaveBillsMutationVariables>;
export const TaskBillModal_ProtoBillsDocument = gql`
    query TaskBillModal_ProtoBills($taskId: ID!) {
  task(id: $taskId) {
    id
    protoBills {
      ...TaskBillModal_ProtoBill
    }
  }
}
    ${TaskBillModal_ProtoBillFragmentDoc}`;

/**
 * __useTaskBillModal_ProtoBillsQuery__
 *
 * To run a query within a React component, call `useTaskBillModal_ProtoBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskBillModal_ProtoBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskBillModal_ProtoBillsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskBillModal_ProtoBillsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables> & ({ variables: TaskBillModal_ProtoBillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>(TaskBillModal_ProtoBillsDocument, options);
      }
export function useTaskBillModal_ProtoBillsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>(TaskBillModal_ProtoBillsDocument, options);
        }
// @ts-ignore
export function useTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>;
export function useTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TaskBillModal_ProtoBillsQuery | undefined, TaskBillModal_ProtoBillsQueryVariables>;
export function useTaskBillModal_ProtoBillsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>(TaskBillModal_ProtoBillsDocument, options);
        }
export type TaskBillModal_ProtoBillsQueryHookResult = ReturnType<typeof useTaskBillModal_ProtoBillsQuery>;
export type TaskBillModal_ProtoBillsLazyQueryHookResult = ReturnType<typeof useTaskBillModal_ProtoBillsLazyQuery>;
export type TaskBillModal_ProtoBillsSuspenseQueryHookResult = ReturnType<typeof useTaskBillModal_ProtoBillsSuspenseQuery>;
export type TaskBillModal_ProtoBillsQueryResult = Apollo.QueryResult<TaskBillModal_ProtoBillsQuery, TaskBillModal_ProtoBillsQueryVariables>;